import API from 'services/API';

export default function saveNotificationsSettings(data) {
  return API.request({
    method: 'POST',
    url: '/notification/subscriptions/update',
    data,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8',
    },
  });
}
